module.exports = __webpack_public_path__ + "assets/img/customer-service.278ea0a8.jpg";